var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");
  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }
  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });
  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first)
      return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== "TAB") return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  elementToFocus.focus();
}
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN"
  ];
  let currentFocusedElement = null;
  let mouseClick = null;
  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });
  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });
  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");
      if (mouseClick) return;
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  // UGC loops govern themselves (assets/ugc-loop.js); pausing them here froze them on every slide change and modal.
  document.querySelectorAll("video:not([data-ugc-video])").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "quantityUpdateUnsubscriber");
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(
      (button) => button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }
  return JSON.stringify(obj);
};
function editorShopifyEvent(t, e, i) {
  let n = false;
  t.type.includes("shopify:section") ? e.hasAttribute("data-section-id") && e.getAttribute("data-section-id") === t.detail.sectionId && (n = true) : t.type.includes("shopify:block") && t.target === e && (n = true), n && i(t);
}
const currencySymbol = {
  AED: "\u062F.\u0625",
  AFN: "\u060B",
  ALL: "L",
  AMD: "\u058F",
  ANG: "\u0192",
  AOA: "Kz",
  ARS: "$",
  AUD: "$",
  AWG: "\u0192",
  AZN: "\u20BC",
  BAM: "KM",
  BBD: "$",
  BDT: "Tk",
  BGN: "\u043B\u0432",
  BHD: ".\u062F.\u0628",
  BIF: "FBu",
  BMD: "$",
  BND: "$",
  BOB: "$b",
  BOV: "BOV",
  BRL: "R$",
  BSD: "$",
  BTC: "\u20BF",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BYR: "Br",
  BZD: "BZ$",
  CAD: "$",
  CDF: "FC",
  CHE: "CHE",
  CHF: "CHF",
  CHW: "CHW",
  CLF: "CLF",
  CLP: "$",
  CNY: "\xA5",
  COP: "$",
  COU: "COU",
  CRC: "\u20A1",
  CUC: "$",
  CUP: "\u20B1",
  CVE: "$",
  CZK: "K\u010D",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "\u062F\u062C",
  EEK: "kr",
  EGP: "\xA3",
  ERN: "Nfk",
  ETB: "Br",
  ETH: "\u039E",
  EUR: "\u20AC",
  FJD: "$",
  FKP: "\xA3",
  GBP: "\xA3",
  GEL: "\u20BE",
  GGP: "\xA3",
  GHC: "\u20B5",
  GHS: "GH\u20B5",
  GIP: "\xA3",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "$",
  HKD: "$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "\u20AA",
  IMP: "\xA3",
  INR: "\u20B9",
  IQD: "\u0639.\u062F",
  IRR: "\uFDFC",
  ISK: "kr",
  JEP: "\xA3",
  JMD: "J$",
  JOD: "JD",
  JPY: "\xA5",
  KES: "KSh",
  KGS: "\u043B\u0432",
  KHR: "\u17DB",
  KMF: "CF",
  KPW: "\u20A9",
  KRW: "\u20A9",
  KWD: "KD",
  KYD: "$",
  KZT: "\u20B8",
  LAK: "\u20AD",
  LBP: "\xA3",
  LKR: "\u20A8",
  LRD: "$",
  LSL: "M",
  LTC: "\u0141",
  LTL: "Lt",
  LVL: "Ls",
  LYD: "LD",
  MAD: "MAD",
  MDL: "lei",
  MGA: "Ar",
  MKD: "\u0434\u0435\u043D",
  MMK: "K",
  MNT: "\u20AE",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "\u20A8",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MXV: "MXV",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "\u20A6",
  NIO: "C$",
  NOK: "kr",
  NPR: "\u20A8",
  NZD: "$",
  OMR: "\uFDFC",
  PAB: "B/.",
  PEN: "S/.",
  PGK: "K",
  PHP: "\u20B1",
  PKR: "\u20A8",
  PLN: "z\u0142",
  PYG: "Gs",
  QAR: "\uFDFC",
  RMB: "\uFFE5",
  RON: "lei",
  RSD: "\u0414\u0438\u043D.",
  RUB: "\u20BD",
  RWF: "R\u20A3",
  SAR: "\uFDFC",
  SBD: "$",
  SCR: "\u20A8",
  SDG: "\u062C.\u0633.",
  SEK: "kr",
  SGD: "S$",
  SHP: "\xA3",
  SLL: "Le",
  SOS: "S",
  SRD: "$",
  SSP: "\xA3",
  STD: "Db",
  STN: "Db",
  SVC: "$",
  SYP: "\xA3",
  SZL: "E",
  THB: "\u0E3F",
  TJS: "SM",
  TMT: "T",
  TND: "\u062F.\u062A",
  TOP: "T$",
  TRL: "\u20A4",
  TRY: "\u20BA",
  TTD: "TT$",
  TVD: "$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "\u20B4",
  UGX: "USh",
  USD: "$",
  UYI: "UYI",
  UYU: "$U",
  UYW: "UYW",
  UZS: "\u043B\u0432",
  VEF: "Bs",
  VES: "Bs.S",
  VND: "\u20AB",
  VUV: "VT",
  WST: "WS$",
  XAF: "FCFA",
  XBT: "\u0243",
  XCD: "$",
  XOF: "CFA",
  XPF: "\u20A3",
  XSU: "Sucre",
  XUA: "XUA",
  YER: "\uFDFC",
  ZAR: "R",
  ZMW: "ZK",
  ZWD: "Z$",
  ZWL: "$"
};
const shopCurrencySymbol = currencySymbol[Shopify.currency.active];
const getSiblings = function(elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};
const slideUp = (target, time) => {
  const duration = time ? time : 500;
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};
const slideDown = (target, time) => {
  let duration = time ? time : 500;
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};
function TopOffset(el) {
  let rect = el.getBoundingClientRect(), scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop };
}
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`
    }
  };
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};
Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );
  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function() {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model"))
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class DataCountdown extends HTMLElement {
  constructor() {
    super();
    this.onCountDown();
  }
  onCountDown() {
    const CountDownElement = this.querySelector("[data-countdown]");
    const countDownItem = (value, label) => {
      return `<div class="countdown-item ${label}"><div class="countdown__inner"><span class="countdown__digit">${value}</span> <span class="countdown__labels">${label}</span></div></div>`;
    };
    const date = new Date(
      CountDownElement.getAttribute("data-countdown")
    ).getTime(), second = 1e3, minute = second * 60, hour = minute * 60, day = hour * 24;
    const countDownInterval = setInterval(function() {
      let currentTime = (/* @__PURE__ */ new Date()).getTime(), timeDistance = date - currentTime, daysValue = Math.floor(timeDistance / day), hoursValue = Math.floor(timeDistance % day / hour), minutesValue = Math.floor(timeDistance % hour / minute), secondsValue = Math.floor(timeDistance % minute / second);
      CountDownElement.innerHTML = countDownItem(daysValue, window.countdown.days) + countDownItem(hoursValue, window.countdown.Hours) + countDownItem(minutesValue, window.countdown.minutes) + countDownItem(secondsValue, window.countdown.second);
      if (timeDistance < 0) clearInterval(countDownInterval);
    }, 1e3);
  }
}
customElements.define("countdown-timer", DataCountdown);
if (!customElements.get("color-swatch-variant")) {
  customElements.define(
    "color-swatch-variant",
    class ColorSwatchVariant extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.productHandle = this.dataset.productHandle;
        this.productCard = this.closest(".product-grid-item");
        this.addEventListener("click", this.onClickHandler.bind(this));
      }
      // Find the <img> inside the card's .media wrapper. May return null if
      // the card structure changes; callers must guard.
      _getDestImg() {
        const media = this.productCard && this.productCard.querySelector(".media");
        if (!media) return null;
        return media.querySelector("img");
      }
      onClickHandler() {
        const destImg = this._getDestImg();
        const colorButtonList = this.productCard ? this.productCard.querySelectorAll(".product--color-swatch") : [];
        colorButtonList.forEach((button) => button.classList.remove("checked-color"));
        this.classList.add("checked-color");
        if (!destImg) {
          return;
        }
        destImg.classList.add("is-fading");
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
        const url = `${root}products/${this.productHandle}?variant=${this.variantId}&view=colorswatchjp`;
        fetch(url).then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        }).then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          this._updateAuxiliaryLinks(html);
          return this.updateThumbnail(html, destImg);
        }).catch((e) => {
          console.error("color-swatch-variant fetch failed:", e);
          destImg.classList.remove("is-fading");
        });
      }
      // Swap the destination <img>'s src/srcset to the variant's image, then
      // fade back in. Silently no-ops if the fetched markup is missing the
      // expected .media img.
      updateThumbnail(html, destImg) {
        const sourceImg = html.querySelector(".media img");
        if (!sourceImg) {
          destImg.classList.remove("is-fading");
          return;
        }
        destImg.src = sourceImg.src;
        if (sourceImg.srcset) destImg.srcset = sourceImg.srcset;
        const decodePromise = typeof destImg.decode === "function" ? destImg.decode().catch(() => {
        }) : new Promise((r) => {
          destImg.addEventListener("load", r, { once: true });
          destImg.addEventListener("error", r, { once: true });
        });
        return decodePromise.then(() => {
          destImg.classList.remove("is-fading");
        });
      }
      // Update the card's image-wrapper anchor and title anchor to point
      // to the chosen variant. Each pair is null-guarded so missing markup
      // doesn't throw.
      _updateAuxiliaryLinks(html) {
        const destImageLink = this.productCard.querySelector(".product__media_thumbnail");
        const sourceImageLink = html.querySelector(".product__media_thumbnail");
        if (destImageLink && sourceImageLink) {
          destImageLink.href = sourceImageLink.href;
        }
        const destTitleLink = this.productCard.querySelector(".product-grid-item__title a");
        const sourceTitleLink = html.querySelector(".product-grid-item__title a");
        if (destTitleLink && sourceTitleLink) {
          destTitleLink.href = sourceTitleLink.href;
        }
      }
    }
  );
}
class ProductBundle extends HTMLElement {
  constructor() {
    super();
    this.wrap = this.querySelector(".products-bundle-group-wrap");
    this.cartNotification = document.querySelector("cart-notification");
    this.cartItems = document.querySelector("cart-items");
    this.addToCartButtonElement = this.querySelector(
      ".bundle-product-submit-button"
    );
    this.bundleTotalPrice = this.querySelector(".bundle-total-price");
    this.itemSelector = this.querySelectorAll("product-bundle-variant-item");
    this.productBundleListWrap = this.querySelector(".product-bundle__list");
    if (this.addToCartButtonElement) {
      this.addToCartButtonElement.addEventListener(
        "click",
        this.handleButtonClick.bind(this)
      );
    }
    this.productBundleItemSelector = this.querySelectorAll("[data-select-id]");
    this.productBundleItemSelector.forEach(
      (block) => block.addEventListener(
        "mouseenter",
        this.handleBlockHover.bind(this, "enter")
      )
    );
    this.productBundleItemSelector.forEach(
      (block) => block.addEventListener(
        "mouseleave",
        this.handleBlockHover.bind(this, "leave")
      )
    );
  }
  handleBlockHover(type, event) {
    if (type === "enter") {
      this.classList.add("is-hover");
      this.toggleBlockActive(event.target, true);
    } else {
      this.classList.remove("is-hover");
      this.toggleBlockActive(null, false);
    }
  }
  toggleBlockActive(target, isActive) {
    this.productBundleItemSelector.forEach((block) => {
      if (target) {
        block.dataset.selectId === target.dataset.selectId ? block.classList.add("active") : block.classList.remove("active");
      } else {
        block.classList.remove("active");
      }
    });
  }
  handleButtonClick(event) {
    event.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("loading");
    const items = {
      items: [...this.querySelectorAll('[name="id"]')].map((e) => e.value).map((e) => ({
        id: e,
        quantity: 1
      }))
    };
    let sectionsToBundle = [];
    if (this.cartNotification) {
      this.cartNotification.getSectionsToRender().map((section) => sectionsToBundle.push(section.id));
      this.cartNotification.setActiveElement(document.activeElement);
    }
    const body = JSON.stringify({
      ...items,
      sections: sectionsToBundle,
      section_url: window.location.pathname
    });
    fetch(`${routes.cart_add_url}?section_id=cart-notification-product`, {
      ...fetchConfig("javascript"),
      body
    }).then((response) => response.json()).then(async (parsedState) => {
      if (parsedState.status) {
        console.log(parsedState.description);
        return;
      }
      if (parsedState.status === 422) {
        console.log("422");
      } else {
        if (this.cartNotification) {
          this.cartNotification.renderContents(parsedState);
        }
        if (this.cartItems) {
          this.cartItems.renderContents(parsedState);
        }
      }
    }).catch((e) => {
      console.error(e);
    }).finally(() => {
      submitButton.classList.remove("loading");
      submitButton.removeAttribute("disabled");
    });
  }
}
customElements.define("products-bundle-group", ProductBundle);
class ProductBundleVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.variantSelect = this.querySelector("select");
    if (this.variantSelect) {
      this.variantSelect.addEventListener(
        "change",
        this.handleVariantChange.bind(this)
      );
    }
  }
  handleVariantChange(event) {
    const variantSelect = event.target;
    const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
    const salePriceElement = this.querySelector(".price__sale");
    salePriceElement.querySelector(
      ".price-item--sale"
    ).innerHTML = `${selectedVariant.dataset.price}`;
    console.log(salePriceElement);
  }
}
customElements.define(
  "product-bundle-variant-item",
  ProductBundleVariantSelector
);
